import React from 'react';
import { Box, Image, Text } from '@chakra-ui/react';

const IconCardXXL = ({ icon, label }) => {
  return (
    <Box
    my={'10px'}
    display="flex"
    alignItems="center"
    justifyContent="center"
    borderRadius="18px"
    w={['200px', '200px', '258px', '258px']}
    h="197px"
    bgColor="#F7F9FE"
  >
    <Image src={icon} boxSize="75px" />
  </Box>
  );
};

export default IconCardXXL;